<template>
  <v-select
    v-bind:id="id || 'facility'"
    :rules="rules"
    :items="allFacilities"
    item-value="id"
    item-title="name"
    :label="label || 'Výdejna stravy'"
    @update:modelValue="onChange"
    :model-value="selectedFacility"
    variant="underlined"
  />
</template>

<script setup>
import {ref, onMounted} from 'vue';
  import _ from 'lodash';

  const props = defineProps({
    /**
     * ID passed to the input.
     */
    id: String,
    /**
     * Array of facility objects.
     */
    allFacilities: Array,
    /**
     * Input label.
     */
    label: String,
    /**
     * Input validation rules.
     */
    rules: Array,
    /**
     * Initial values.
     */
    initialValues: Object,
  });

  const emit = defineEmits(['facilityChanged']);

  const selectedFacility = ref(
      props.initialValues?.facility ? Number(props.initialValues?.facility) : null
  );

  onMounted(() => {
    emit('facilityChanged', {
      pristine: _.isEqual(props.initialValues?.facility, selectedFacility.value),
      value: { facility: selectedFacility.value },
      valid: typeof selectedFacility.value === 'number',
    });
  });

  const onChange = (value) => {
    selectedFacility.value = value
    emit('facilityChanged', {
      pristine: _.isEqual(props.initialValues?.facility, value),
      value: { facility: value },
      valid: typeof value === 'number',
    });
  };
</script>

<style scoped>
</style>
